<template>
  <div class="content">
      <div class="search-area">
                <div class="w100f t-left mb15"><b>选择需要导入的数据</b></div>
                <div class="import-a-sty">
                    <a class="fontC-4fa1a4">销售流向导入</a><label> | </label>
                    <a>销售流向导入</a><label> | </label>
                    <a>销售流向导入</a><label> | </label>
                    <a>销售流向导入</a><label> | </label>
                </div>
      </div> 
      <div class="search-area mt15">
            <div class="import-sty">
                    <el-steps :active="active" align-center>
                      <el-step title="上传文件"></el-step>
                      <el-step title="确认数据"></el-step>
                      <el-step title="导入完成"></el-step> 
                    </el-steps>
                    <div class="ml71">
                          <div class="mt15 mt50">下载模板：<el-button plain size="medium" @click="">下载文件模板</el-button></div>
                          <div class="mt15 mt15 h120"><p class="fl">导入文件：</p>
                          <!-- <el-button size="medium" type="info" @click="add(1, '')">点击上传文件</el-button> -->
                                <el-upload
                                  class="upload-demo fl"
                                  action="#"  
                                  :before-upload="beforeUpload"
                                  multiple
                                  :limit="1"
                                  accept=".xlsx,.xsl,.xls,.xlsm"
                                  :on-change="changeFile"
                                  :on-exceed="handleExceed">
                                  <el-button size="medium" type="info">点击上传文件</el-button>
                                  <div slot="tip" class="el-upload__tip">
                                  当前仅支持 excel 格式文件（大小在2M以内），请使用 Office 2010 及以上版本，否则可能出现乱码<br>
                                  必须严格按照模板内容填入数据，否则可能会出现导入异常
                                  </div>
                                </el-upload>
                          </div> 
                    </div> 
                    <div class="mt15 t-right">
                          <el-button size="medium" plain @click="add(1, '')">取消</el-button>
                          <el-button size="medium" type="info" @click="add(1, '')">下一步</el-button>
                    </div> 
            </div>
      </div> 
  </div>
</template>

<script>
import {route}  from '@/api/apiRoute';
import store from '@/store'
export default {
  data() {
    return { 
      url:`/${serverConfig.msCommonAdminCloudService}/obs/upload-image`,
        token:{
          'Content-Type': 'multipart/form-data',
          'Authorization':store.state.token
        },
      active: 0,
     srcs: '',
     winHeight: window.innerHeight,
      height: {
        height: '',
      },
    };
  },
  created() {  
    // this.src = '';
    // this.getSrc();  
  },   
  watch: {  
  },
  mounted(){    
  
  }, 
  methods: {
       beforeUpload(file) {
            let filename = file.name
            let arr = filename.split('.')
            if (arr[1] !== 'xls' && arr[1] !== 'xlsx'&& arr[1] !== 'xlsm') {
              this.$message.error('上传文件只能是 excel/xls 格式!')
              return false
            }
            return arr
      }, 
      handleExceed(files, fileList) {
        this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
      },
      changeFile(file,fileList) {
           let self = this;
           console.log(file,fileList);
            // let formData = new FormData();
            // formData.append('file',file.raw);//传文件
            // self.api.postImage(self.url,formData).then(function(res){
            //   if (res.data.success) {
            //     self.$message({
            //       type: 'success',
            //       message: '上传成功'
            //     })
            //     // self.currentNodeData(self.dataObj.setId)  //此方法是重新刷数据，可以自己写
            //   } else {
            //     self.$message({
            //       type: 'warning',
            //       message: res.data.msg
            //     })
            //     return false
            //   }
            // })
      }
  },
};
</script>
<style  scoped>
/deep/ .el-step__icon.is-text {
    border-radius: 50%;
    border-color:#4fa1a4;
    border-color: inherit;
}
/deep/ .el-step__icon-inner {
    color: #4fa1a4;
}
/deep/ .el-step__title.is-process {
    color: #4fa1a4;
}
</style>